import { colorGetLighter } from "src/app/support/colors";

export function toDuotoneIcon(icon: string): string {
  if (icon.includes("fa-duotone")) {
    return icon;
  }

  return icon
    .replace(/\bfa-light\b/, "fa-duotone")
    .replace(/\bfa-solid\b/, "fa-duotone")
    .replace(/\bfa-thin\b/, "fa-duotone")
    .replace(/\bfa-regular\b/, "fa-duotone");
}

export function toSolidIcon(icon: string): string {
  if (icon.includes("fa-solid")) {
    return icon;
  }

  return icon
    .replace(/\bfa-light\b/, "fa-solid")
    .replace(/\bfa-duotone\b/, "fa-solid")
    .replace(/\bfa-thin\b/, "fa-solid")
    .replace(/\bfa-regular\b/, "fa-solid");
}

export function getDuotoneIconStyle(color: string): Record<string, string> {
  return {
    "--fa-primary-color": color,
    "--fa-secondary-color": colorGetLighter(color, 45),
    "--fa-primary-opacity": "1",
    "--fa-secondary-opacity": "0.35"
  };
}
